<div class="mobile-nav-title" i18n>WORK ORDERS</div>
<div class="container-fluid">
    <form class="row" (ngSubmit)="loadWorkOrders()">
        <div class="col-sm-2">
            <input name="projectName" id="projectName"
                   class="form-control" placeholder="Search Projects" i18n-placeholder
                   [(ngModel)]="filter.projectName" #projectName="ngModel" />
        </div>
        <div class="col-sm-2">
            <select name="customerId" id="customerId"
                    class="form-control select-bidit"
                    [(ngModel)]="filter.customerId" #customerId="ngModel">
                <option selected="selected" value="undefined" i18n>Select Customer</option>
                <option *ngFor="let customer of summary?.customers" [ngValue]="customer.customer_ID">{{customer.customer_BusinessName}}</option>
            </select>
        </div>
        <div class="col-sm-2">
            <mat-select class="form-control"
                        [(value)]="filter.crew">
                <mat-select-trigger>
                    <div *ngIf="filter.crew; else noCrew">
                        <div class="color-swatch"
                             [style.background-color]="filter.crew.crew_Color">
                            &nbsp;
                        </div>
                        {{filter.crew.crew_Name}}
                    </div>
                    <ng-template #noCrew i18n>Select Crew</ng-template>
                </mat-select-trigger>
                <mat-option value="" i18n>Select Crew</mat-option>
                <mat-option *ngFor="let crew of summary?.crews" [value]="crew">
                    <div class="color-swatch" [style.background-color]="crew.crew_Color">&nbsp;</div>
                    {{crew.crew_Name}}
                </mat-option>
            </mat-select>
        </div>
        <div class="col-sm-2">
            <select name="jobTypeId" id="jobTypeId"
                    class="form-control select-bidit"
                    [(ngModel)]="filter.jobTypeId" #jobTypeId="ngModel">
                <option [ngValue]="null" i18n>Select Job Type</option>
                <option *ngFor="let jobType of summary?.jobTypes" [ngValue]="jobType.jobType_ID">{{jobType.jobType_Desc}}</option>
            </select>
        </div>
        <div class="col-6">
            <div class="control-wrapper">
                <label for="startDateCtrl" class="col-form-label" i18n>Start Date</label>
                <div class="form-inline">
                    <input name="startDateCtrl" id="startDateCtrl" class="form-control narrow-input" matInput
                           placeholder="mm/dd/yyyy"
                           [matDatepicker]="startPicker"
                           [(ngModel)]="filter.startDate" #startDateCtrl="ngModel" />
                    <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                    <mat-datepicker #startPicker></mat-datepicker>
                </div>
            </div>
        </div>
        <div class="col-6">
            <div class="control-wrapper">
                <label for="endDateCtrl" class="col-form-label" i18n>End Date</label>
                <div class="form-inline">
                    <input name="endDateCtrl" id="endDateCtrl" class="form-control narrow-input" matInput
                           placeholder="mm/dd/yyyy"
                           [matDatepicker]="endPicker"
                           [(ngModel)]="filter.endDate" #endDateCtrl="ngModel" />
                    <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                    <mat-datepicker #endPicker></mat-datepicker>
                </div>
            </div>
        </div>
        <div class="col-sm-2 mb-2">
            <button type="submit" class="text-white float-right btn btn-bidit-submit" i18n>Apply Filter</button>
        </div>
    </form>
  <div
        infiniteScroll
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="50"
        (scrolled)="onScroll()">
    <div *ngFor="let workOrder of workOrders">
      <div class="card bg-light border-bidit-dark mb-3 shadow">
        <div class="card-body">
          <div class="form-inline col">
            <!--<div class="col text-bidit-primary-header"></div>-->
            <div class="text-bidit-primary-header">{{workOrder.customer.customer_BusinessName}}</div>
          </div>
          <div class="col">
            <label class="text-bidit-primary" i18n>Project:</label>
            <a *ngIf="canEdit" (click)="editWorkOrder(workOrder)" class="mobile-link">{{workOrder.project.quote_Name}} #{{workOrder.project.quote_ProjectNumber}}</a>
            <h5 *ngIf="!canEdit">{{workOrder.project.quote_Name}} #{{workOrder.project.quote_ProjectNumber}}</h5>
          </div>
          <div class="form-inline">
            <div class="form-inline col-8">
              <label class="text-bidit-primary" i18n>Work Order:</label>
              <span class="text-bidit-primary">{{workOrder.project.quote_ProjectNumber}}-{{workOrder.workOrder_Seq}}</span>
            </div>
            <div class="float-right" *ngFor="let woc of workOrder.workOrderCrews">
              <div class="form-inline">
                <div class="square mr-2" [ngStyle]="{'background-color': woc.crew?.crew_Color}"></div>
                <span class="text-bidit-primary">{{woc.crew?.crew_Name}}</span>
              </div>
            </div>
          </div>

          <div *ngIf="workOrder.workOrderType" class="form-inline col-6">
            <label class="text-bidit-primary" i18n>Type:</label>
            <span class="text-bidit-primary">{{workOrder.workOrderType.workOrderType_Desc}}</span>
          </div>
          <div *ngIf="workOrder.project.jobType" class="form-inline col-6">
            <label class="text-bidit-primary" i18n>Job Type:</label>
            <span class="text-bidit-primary">{{workOrder.project.jobType.jobType_Desc}}</span>
          </div>
          <div *ngIf="workOrder.workOrderStatus" class="form-inline col-6">
            <label class="text-bidit-primary" i18n>Status:</label>
            <span class="text-bidit-primary">{{getWorkOrderStatusName(workOrder.workOrderStatus_ID)}}</span>
          </div>
          <div class="form-inline">
            <div class="col-8 form-inline">
              <label class="text-bidit-primary" i18n>Scheduled For:</label>
              <span class="text-bidit-primary">{{workOrder.workOrder_Start | date:'M/d/yyyy'}}</span>
            </div>
            <div class="float-right">
              <button *ngIf="canEdit" (click)="workOrderResources(workOrder)" class="btn btn-bidit-navigate mr-1" i18n>Resources</button>
              <button *ngIf="canEdit" (click)="workOrderLabor(workOrder)" class="btn btn-bidit-navigate mr-1" i18n>Labor</button>
              <button (click)="printWorkOrder(workOrder)" class="btn btn-bidit-action" i18n>Print</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
